/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { ArrowNextIcon } from '@coursera/cds-icons';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';

type Props = {
  buttonLabel?: string | null;
  handleNavButtonClick: () => void;
  'aria-describedby': string;
};

/**
 * Wrapper around CoachButton for navigation specific use cases.
 */
export const NavigationButton = (props: Props): React.ReactElement => {
  const { buttonLabel, handleNavButtonClick, 'aria-describedby': ariaDescribedBy } = props;

  return (
    <CoachButton
      aria-describedby={ariaDescribedBy}
      icon={<ArrowNextIcon color="invert" />}
      size="small"
      fullWidth
      justifyContent="space-between"
      onClick={handleNavButtonClick}
    >
      {buttonLabel || ''}
    </CoachButton>
  );
};

export default NavigationButton;
